"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTelemetrySettings = exports.createSettings = void 0;
const TrouterUtils_1 = require("./TrouterUtils");
const TrouterConfigClient_1 = require("./TrouterConfigClient");
const defaultSettings = {
    version: "1.0.0", // SignalingClient version, required for trouter connection
    registrationId: "", // Required for trouter connection
    sessionId: "", // Required for trouter connection
    pnhAppId: "AcsWeb",
    pnhTemplate: "AcsWeb_Chat_2.1",
    platform: "SPOOL",
    platformUIVersion: "0.0.0",
    environment: "", // TBD
    productName: "acs-chat-web",
    trouterServiceUrl: "",
    registrarServiceUrl: "",
    registrarRefreshTimeoutInMs: 350000,
    timeoutOptions: {
        connectionTimeoutMs: 20000,
        fetchTimeoutMs: 10000,
        pingTimeoutMs: 40000,
        pongTimeoutMs: 5000,
        maxBackoffMs: 50000,
        requestTimeoutMs: 5000,
    },
    maxRegistrationTimeInMs: 7200000,
};
// Main function to create settings based on environment
const createSettings = (credential, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const endpoint = options === null || options === void 0 ? void 0 : options.resourceEndpoint;
    // Throw an error if resourceEndpoint is null or undefined
    if (endpoint === undefined) {
        throw new Error("'endpoint' cannot be null");
    }
    // Initialize the settings by cloning the default ones
    const settings = Object.assign({}, defaultSettings);
    settings.registrationId = (0, TrouterUtils_1.generateUuid)(); // Generate unique IDs
    settings.sessionId = (0, TrouterUtils_1.generateUuid)();
    // Fetch the real time configuration from the service
    const trouterConfigClient = new TrouterConfigClient_1.TrouterConfigClient(endpoint, options);
    const realTimeNotificationConfiguration = yield trouterConfigClient.fetchServiceUrls(credential);
    // Append suffix to trouterServiceUrl and registrarServiceUrl
    settings.trouterServiceUrl = `${realTimeNotificationConfiguration.trouterServiceUrl}/v4/a`;
    settings.registrarServiceUrl = `${realTimeNotificationConfiguration.registrarServiceUrl}/v3/registrations`;
    // Customize settings if the environment is INT
    if (realTimeNotificationConfiguration.cloudType === "int") {
        settings.pnhAppId = "cns-e2e-test";
        settings.pnhTemplate = "cns-e2e-test:1.8";
    }
    settings.maxRegistrationTimeInMs =
        (_a = options === null || options === void 0 ? void 0 : options.registrationTimeInMs) !== null && _a !== void 0 ? _a : defaultSettings.maxRegistrationTimeInMs;
    return settings;
});
exports.createSettings = createSettings;
exports.defaultTelemetrySettings = {
    // TBD Can we hook up OpenTelemetry?
    enabled: false,
};
